<template>
  <div class="stats">
    <b-field>
    <b-radio-button
        v-for="availableYear in years"
        :key="availableYear"
        v-model="year"
        :native-value="availableYear"
        type="is-primary is-light is-outlined"
    >
      {{ availableYear }}
    </b-radio-button>
    </b-field>

    <div class="stats-table">
    <b-table
        v-if="true"
        :data="data"
        aria-current-label="Current page"
        aria-next-label="Next page"
        aria-page-label="Page"
        aria-previous-label="Previous page"
        default-sort="name">

      <template>
        <b-table-column field="month" label="Monat" sortable width="100" v-slot="props">
          {{ formatMonth(props.row.month) }}
        </b-table-column>

        <b-table-column field="revenue" label="Umsatz" numeric sortable width="200" v-slot="props">
          {{ formatEuro(props.row.revenue) }}
        </b-table-column>

      </template>
    </b-table>
    </div>





  </div>
</template>

<script>



import apiservice from "@/services/apiservice";

export default {
  name: 'StockValue',
  props: {
    msg: String
  },
  components: {
    // ArticleCategory
  },
  data() {
    return {
      data: [],
      year: new Date().getFullYear(),
      items: [],
      isLoading: false
    }
  },
  computed: {
    years() {
      const startYear = 2025;
      const currentYear = new Date().getFullYear();

      return Array.from(
          { length: currentYear - startYear + 1 },
          (_, index) => startYear + index
      );
    }
  },
  methods: {
    fetchData: function() {
      this.isLoading = true;
      let self = this;

      apiservice()
          .get(`stats/revenue/monthly?year=${this.year}`)
          .then(response => {
            this.data = response.data.data
            this.isLoading = false
          })
          .catch(function (error) {
            self.isLoading = false
            if (error.response.status == 403) {
              self.$buefy.dialog.alert({
                title: 'Fehler',
                message: 'Du hast keine Berechtigung für diese Aktion.',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            } else {
              self.$buefy.dialog.alert({
                title: 'Fehler',
                message: 'Ein Fehler ist beim Abrufen der Daten aufgetreten. Möglicherweise hast du keine Berechtigung für diese Aktion.',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            console.log(error);
          });


    },

    stockTable: function(rawdata) {
      let stockTable = []

      for (const [wkey, wvalue] of Object.entries(rawdata)) {



        let wsum = 0;
        let ritems = [];
        for (const [rkey, rvalue] of Object.entries(wvalue)) {

          let rsum = 0
          let sitems = []
          for (const [skey, svalue] of Object.entries(rvalue)) {
            sitems.push({name:"Fach " + skey, value:svalue})
            if (svalue) {
              rsum += svalue
            }
          }
          ritems.push({name:"Regal " + rkey, value:rsum, items: sitems})
          wsum += rsum


        }
        stockTable.push({name:"Halle " + wkey, value:wsum, items:ritems})


      }
      return stockTable;
    },
    finRound: function(amount){
      return (Math.round(amount * 100) / 100).toFixed(2);
    },
    formatEuro: function(amount) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
     },
    formatMonth: function(month) {
      return new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(new Date(2000, month - 1, 1));
     }

  },
  watch: {
    year() {
      this.fetchData()
    }
  },
  beforeMount() {
    this.fetchData()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.stats-table {
  display: inline-block;
  max-width: 100%;
}

.stats-table >>> .table {
  width: auto;
}

.stats-table >>> .table td,
.stats-table >>> .table th {
  padding: 0.35rem 0.65rem;
  white-space: nowrap;
}
</style>
